module.exports = __webpack_public_path__ + "media/flags/uk-15c1cd7e.svg";